export const Environment = {
  API_PATH: '/api/v1/',
  TITLE: 'Fluidilogix',
  LOGO: '/assets/logo.png',
}
